<template>
    <label class="relative block">
        <template v-if="label || $slots.label">
            <slot name="label">
                <span v-html="label"></span>
            </slot>
        </template>
        <textarea
            v-if="type === 'textarea'"
            v-model="model"
            :class="{'form-input-error': error, 'cursor-not-allowed opacity-50': disabled}"
            :disabled="disabled"
            :placeholder="placeholder"
            :required="required"
            class="form-textarea mt-1 block w-full"
            rows="3"
        ></textarea>
        <input
            v-else
            v-model="model"
            :class="{'form-input-error': error, 'cursor-not-allowed opacity-50': disabled}"
            :disabled="disabled"
            :placeholder="placeholder"
            :required="required"
            :type="type"
            class="form-input mt-1 block w-full">
        <small
            v-if="error && showError"
            class="absolute block text-red-600 mt-1"
            v-text="error"/>
    </label>

</template>


<script>

import InputMixin from "@global/Mixins/InputMixin";

export default {

    mixins: [InputMixin],

    props: {
        type: {
            type: String,
            default: 'text'
        },
        disabled: {
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        placeholder: String,
    }
}

</script>
